import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Permission } from '../common/enums/permissions';
import { AuthGuard } from '../core/authentication/auth.guard';
import { PermissionGuard } from '../core/authentication/permission.guard';
import { LegalizationRegistryTabsContainerComponent } from './legalization-registry-tabs-container/legalization-registry-tabs-container.component';
import { SuccessfullySumbitForLegalizationComponent } from './successfully-sumbit-for-legalization/successfully-sumbit-for-legalization.component';

const routes: Routes = [
  {
    path: 'legalizations',
    component: LegalizationRegistryTabsContainerComponent,
    canActivate: [
      AuthGuard,
      PermissionGuard
    ],
    data: {
      permissions: [
        Permission.ShowAllLegalizations,
        Permission.ShowEmployerObjectLegalizations,
        Permission.GetAllLegalizationDocuments,
        Permission.GetEmployerObjectLegalizationDocuments
      ],
    },
  },
  { path: 'legalizations/successfullySubmitForLegalization/:id', component: SuccessfullySumbitForLegalizationComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class LegalizationsRoutingModule {}
